module.exports = __webpack_public_path__ + "imgs/merchandise.5474c56d808896ab864b8f334a9eadac.jpg";